import React from 'react'
import { Link } from 'react-router-dom'

const AboutSection = () => {
  return (
    <section className="about-section-two">
  <div className="anim-icons">
    <span className="icon icon-circle-3" />
    <span className="icon icon-circle-4" />
  </div>
  <div className="auto-container">
    <div className="row">
      {/* Content Column */}
      <div className="content-column col-lg-8 col-md-12 col-sm-12">
        <div className="inner-column">
          <div className="sec-title">
            <span className="sub-title">Get the latest info about</span>
            <h2>
              Conference For Solving <br />
              Problems For Your Business
            </h2>
            <span className="divider" />
            <div className="text">
              Influential media, entertainment &amp; technology show
              inspirational speakers including game changing not just a
              large-scale conference, but a large educational hub on digital
              technologies for business, where people communicate, get inspired
              and find ready-made.
            </div>
          </div>
        </div>
      </div>
      {/* Date Column */}
      <div className="date-column col-lg-4 col-md-12 col-sm-12">
        <div className="date-box-outer">
          {/* Date Box Two / Yellow  */}
          <div className="date-box-one bg_yellow order-2">
            <span className="day">18</span>
            <span className="month">September</span>
            <span className="title">Conferance Day Now </span>
          </div>
          {/* Date Box One / Blue  */}
          <div className="date-box-one">
            <span className="day">17</span>
            <span className="month">September</span>
            <span className="title">Exhibition and Side Events</span>
          </div>
        </div>
      </div>
    </div>
    {/* Fact Counter Two */}
    <div className="fact-counter-two">
      <div className="row clearfix">
        {/*Column*/}
        <div className="counter-column col-lg-3 col-md-6 col-sm-12">
          <div className="inner-box">
            <div className="count-box">
              <span className="count-text" data-speed={3000} data-stop={54}>
                0
              </span>
              <span className="counter-title">Speakers</span>
            </div>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12"
          data-wow-delay="300ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="count-text" data-speed={3000} data-stop={600}>
                0
              </span>
              <span className="counter-title">Tickets</span>
            </div>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn"
          data-wow-delay="600ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="count-text" data-speed={3000} data-stop={18}>
                0
              </span>
              <span className="counter-title">Sponsors</span>
            </div>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn"
          data-wow-delay="900ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="count-text" data-speed={3000} data-stop={35}>
                0
              </span>
              <span className="counter-title">Sessions</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Video Box Outer */}
    <div className="video-box-outer">
      {/* Video Box */}
      <div className="video-box-one order-2">
        <figure className="image">
          <img src="images/resource/image-1.jpg" alt="" />
        </figure>
        <Link 
          to="https://www.youtube.com/watch?v=kxPCFljwJws"
          className="lightbox-image play-btn wow fadeIn"
          data-wow-delay="500ms"
        >
          <i className="icon flaticon-play-button-1" />
        </Link> 
      </div>
      {/* Info Box */}
      <div className="info-box-one">
        <div className="inner-box">
          <h4>Mind Blowing Was Last Year 2023</h4>
          <p>
            We have dedicated tracks for every industry Whether you want to hire
            tech’s top talent meet with the policymakers.
          </p>
          {/* <Link  to="buy-ticket.html" className="theme-btn btn-style-two">
            <span className="btn-title">Book Ticket</span>
          </Link>  */}
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default AboutSection